import React, { useEffect, useContext } from 'react';

import AppContext from '../../AppContext';
import config from '../../config';

import Section from '../Section';
import Column from '../Column';
import Panel from '../Panel';

const HeroSection = ({ site, pageIndex, viewer = {}, hiddenPanels, onHidePanel }) => {
  const { display = true, panels = [], height = 'fit-content', ...viewerProperties } = viewer;
  const { isViewerFullScreen } = useContext(AppContext);
  const { setIsFullScreen } = useContext(AppContext);

  useEffect(() => {
    if (!display) setIsFullScreen(false);
  }, [display, setIsFullScreen]);

  return (
    <Section
      className={`hero-section-component ${display ? 'visible' : 'hidden'}`}
      height={height}
      align
    >
      {!config.onPremise && display && (
        <Column>
          <Panel
            pageIndex={pageIndex}
            sectionIndex={'viewer'}
            sectionHeight={height}
            type="viewer"
            site={site}
            options={{ display, ...viewerProperties }}
          />
        </Column>
      )}
      {panels?.length > 0 && display
        ? panels.map((panel) => (
            <Column key={panel.id}>
              <Panel
                hidePanel={
                  hiddenPanels.includes(panel.id) ||
                  (isViewerFullScreen && panel.options && !panel.options.allowFloat)
                }
                pageIndex={pageIndex}
                sectionIndex={'viewer'}
                sectionHeight={height}
                key={panel.id}
                site={site}
                type={panel.type}
                options={panel.options}
                onHidePanel={onHidePanel}
                {...panel}
              />
            </Column>
          ))
        : null}
    </Section>
  );
};

export default HeroSection;
